import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { isArray, isObject, isEmpty } from 'lodash';
import Spinner from './Spinner/Spinner';
import TollFreeNumber from './TollFreeNumber';

const QueryLrnModal = ({ isOpen, onCancel, data, onUpdate, selectedNumberTitle }) => {
  const [state, setState] = useState(data?.lrn);

  useEffect(() => {
    setState(isArray(data) ? data : data?.lrn);
  }, [data]);

  console.log('state______', state, isOpen);

  // eslint-disable-next-line no-nested-ternary
  return isArray(state) && !isEmpty(state) ? (
    <TollFreeNumber history={state} isOpen={isOpen} onCancel={onCancel} />
  ) : isObject(state) ? (
    <Modal isOpen={isOpen}>
      <ModalHeader>{selectedNumberTitle}</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label for="callername" sm={4}>
            LRN:
          </Label>
          <Col sm={8}>
            <Input disabled required type="text" placeholder="LRN..." value={state.LRN} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            OCN:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="OCN..."
              value={state.OCN}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="city" sm={4}>
            LATA:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="LATA..."
              value={state.LATA}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            CITY:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="CITY..."
              value={state.CITY}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            RC:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="RC..."
              value={state.RC}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            STATE:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="STATE..."
              value={state.STATE}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            JURISDICTION:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="JURISDICTION..."
              value={state.JURISDICTION}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            LOCAL:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="LOCAL..."
              value={state.LOCAL}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            LEC:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="LEC..."
              value={state.LEC}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="address1" sm={4}>
            LECTYPE:
          </Label>
          <Col sm={8}>
            <Input
              disabled
              autocomplete="off"
              required
              type="text"
              placeholder="LECTYPE..."
              value={state.LECTYPE}
            />
          </Col>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  ) : (
    <Spinner />
  );
};

export default QueryLrnModal;
